import { render } from "./MenuService.vue?vue&type=template&id=4c4c4cd1&scoped=true"
import script from "./MenuService.vue?vue&type=script&lang=js"
export * from "./MenuService.vue?vue&type=script&lang=js"

import "./MenuService.vue?vue&type=style&index=0&id=4c4c4cd1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c4c4cd1"

export default script